import React, { Component } from "react"
import _ from "lodash"
import Input from "react-toolbox/lib/input/Input"
import Dropdown from "react-toolbox/lib/dropdown/Dropdown"
import Autocomplete from "react-toolbox/lib/autocomplete/Autocomplete"
import Button from "react-toolbox/lib/button/Button"
import * as strings from "../../strings"
import DateRange from "../DateRange"
import Hidable from "../Hidable"

import styles from "./styles.css"

export default class SearchFilter extends Component {
  props: {
    procedureSearch: ( n: mixed ) => mixed,
    suggestions: {
      litiagtionTypes: [],
      preLitiagtionTypes: [],
      clients: [],
      debtPhases: [],
      taxTypes: [],
      PaymentAgreementStatusEnum: [],
      PaymentAgreementTypeEnum: [],
    },
    onChange: ( e: any ) => mixed,
    value: any,
    expanded: boolean,
    onExpand: () => mixed,
  }

  prepareDropdownSource ( srvSrc: any ) {
    if ( !srvSrc ) {
      return []
    }

    const values = [ {
      value: undefined,
      label: "",
    },
    ..._.map( srvSrc, c => ( {
      value: c.id,
      label: c.name,
    } ) ) ]

    return _.orderBy( values, "label" )
  }


  prepareAutocompleteSource ( srvSrc: any ) {
    if ( !srvSrc ) {
      return []
    }

    return srvSrc.reduce( ( acc, opt ) => ( {
      ...acc,
      [ opt.id ]: opt.name,
    } ), {} )
  }


  setInputData ( inputName: string, data: any ) {
    const newFilters = {
      ...this.props.value,
      [ inputName ]: data,
    }
    const cleanFilters = _.omitBy( newFilters, _.isUndefined )

    this.props.onChange( cleanFilters )
  }


  renderRow = (
    inputsArr: [ {
    type: string,
    key: string,
    value: any,
    label: string,
    source: any
    } ],
    rowIndex: number,
    isDarkRow: boolean
  ) => {
    const preparedArr = _.chunk( inputsArr, 2 )
    const wrapperClassName = [
      styles.rowWrap,
      isDarkRow ? styles.darkBackground : "",
    ].join( " " )
    return (
      <div className={wrapperClassName} key={rowIndex}>
        {
          preparedArr.map( ( subArray, index ) => {
            return (
              <div className={styles.row} key={index}>
                {
                  subArray.map( ( elObj ) => {
                    return this.createElement( elObj )
                  } )
                }
              </div>
            )
          } )
        }
      </div>
    )
  }

  createElement = (
    elObj: {
    type: string,
    key: string,
    label: string,
    source?: any,
    render?: boolean,
    isDisbled?: boolean,
    prepareToSend: ( string ) => mixed,
    } ) => {

    const { type, key, label, source, isDisbled } = elObj
    const prepareToSend = elObj.prepareToSend || ( x => x )


    if ( !key || !type && !typeMatch[ type ] || !label ) {
      return ( !elObj.render ) ? "" : ( <div/> )
    }

    const typeMatch = {
      "input": ( <Input></Input> ),
      "dropdown": ( <Dropdown></Dropdown> ),
      "date": ( <DateRange></DateRange> ),
      "autocomplete": ( <Autocomplete></Autocomplete> ),
    }

    const preparedObj = {
      value: this.props.value[ key ],
      label,
      source,
      onChange: value => this.setInputData( key, prepareToSend( value ) ),
      title: label,
      disabled: isDisbled === true,
      auto: type === "dropdown" ? true : undefined,
      className: type === "date" ? styles.datePickerRoot : undefined,
      multiple: type === "autocomplete" ? false : undefined,
      direction: type === "autocomplete" ? "down" : undefined,
      suggestionMatch: type === "autocomplete" ? "anywhere" : undefined,
      ...elObj.extraProps,
    }

    const element = React.cloneElement( typeMatch[ type ], preparedObj )

    return element
  }

  render () {
    const suggestions = this.props.suggestions

    const searchConfig = [
      [
        {
          type: "input",
          key: "processNumber",
          label: strings.processes.injunctionOrExecutionNumber,
        }, {
          type: "input",
          key: "debtorName",
          label: strings.generalStrings.responsibleEntity,
        }, {
          type: "input",
          key: "idc",
          label: strings.generalStrings.caseId,
        }, {
          type: "input",
          key: "nif",
          label: strings.paymentAgreements.defendantsNif,
        },
      ], [
        {
          type: "dropdown",
          key: "segment",
          label: strings.generalStrings.segment,
          source: [ {
            value: undefined,
            label: "",
          }, {
            value: null,
            label: "Sem segmento",
          }, {
            value: "B2B",
            label: "B2B",
          }, {
            value: "B2C",
            label: "B2C",
          } ],
        }, {
          type: "dropdown",
          key: "typeId",
          prepareToSend: _.parseInt,
          label: strings.processes.processType,
          source: this.prepareDropdownSource( _.get( suggestions, "types", [] ) ),
        }, {
          type: "dropdown",
          key: "state",
          label: strings.processes.processPhase,
          source: this.prepareDropdownSource(
            _.chain( suggestions )
              .get( "states", [] )
              .uniqBy( "name" )
              .map( state => ( {
                id: _.get( state, "name" ),
                name: _.get( state, "name" ),
              } ) )
              .value()
          ),
        }, {
          type: "dropdown",
          key: "subtypeId",
          prepareToSend: _.parseInt,
          label: strings.processes.processSubType,
          source: this.prepareDropdownSource( _.get( suggestions, "subtypes", [] ) ),
        },
      ], [
        {
          type: "input",
          key: "valueMin",
          prepareToSend: parseFloat,
          label: strings.paymentAgreements.minActionValue,
          extraProps: {
            icon: "euro_symbol",
          },
        }, {
          type: "input",
          key: "valueMax",
          prepareToSend: parseFloat,
          label: strings.paymentAgreements.maxActionValue,
          extraProps: {
            icon: "euro_symbol",
          },
        }, {
          type: "dropdown",
          key: "paymentAgreementStatus",
          label: strings.paymentAgreements.paymentAgreementStatus,
          source: this.prepareDropdownSource(
            _.get( suggestions, "PaymentAgreementStatusEnum", [] ).map( suggestion => ( {
              id: suggestion.name,
              name: strings.PaymentAgreementStatusTranslation[ suggestion.name ],
            } ) )
          ),
        }, {
          type: "dropdown",
          key: "paymentAgreementType",
          label: strings.paymentAgreements.paymentAgreementType,
          source: this.prepareDropdownSource(
            _.get( suggestions, "PaymentAgreementTypeEnum", [] ).map( suggestion => ( {
              id: suggestion.name,
              name: strings.PaymentAgreementTypeTranslation[ suggestion.name ],
            } ) )
          ),
        },
      ], [
        {
          type: "date",
          key: "importDate",
          label: strings.generalStrings.importDate,
        },
        {
          type: "date",
          key: "entryDate",
          label: strings.generalStrings.citiusEntryDate,
        },
        {
          type: "date",
          key: "date",
          label: strings.generalStrings.categorizationChangeDate,
        },
        {
          type: "date",
          key: "paymentRegistrationDate",
          label: strings.paymentAgreements.paymentRegistrationDate,
        },
        {
          type: "dropdown",
          key: "clientId",
          prepareToSend: _.parseInt,
          label: strings.generalStrings.company,
          source: this.prepareDropdownSource( _.get( suggestions, "clients", [] ) ),
        }, {
          type: "autocomplete",
          key: "courtId",
          prepareToSend: _.parseInt,
          label: strings.paymentAgreements.court,
          source: this.prepareAutocompleteSource( _.get( suggestions, "courts", [] ) ),
        },
      ],
    ]

    return (
      <div className={styles.container}>
        <Hidable
          title={strings.generalStrings.filter}
          onToggle={this.props.onExpand}
          expanded={this.props.expanded}
        >
          <div className={styles.column}>
            {
              searchConfig.map( ( row, index ) => {
                const isDarkRow = index % 3 === 2
                return this.renderRow( row, index, isDarkRow )
              } )
            }
            <div className={styles.buttonWrapper}>
              <Button
                className={styles.button}
                icon="search"
                label={strings.search.search}
                raised
                primary
                onClick={() => this.props.procedureSearch( this.props.value )}
              />
            </div>
          </div>

        </Hidable>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchFilter/index.jsx